import { render } from "./MainProducts.vue?vue&type=template&id=589cdd89&scoped=true"
import script from "./MainProducts.vue?vue&type=script&lang=js"
export * from "./MainProducts.vue?vue&type=script&lang=js"

import "./MainProducts.vue?vue&type=style&index=0&id=589cdd89&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589cdd89"]])

export default __exports__